import Header from '../../ProjectCreation/Header2'
import React, { useState, useEffect } from "react";
import "../../styles/costlineStyle.css";
import { useSelector, useDispatch } from "react-redux";
import { selectPeriod, selectCategory, addElement, updateElement, setPeriods, updatePeriods, pasteCategoryElements } from "../../Redux/slices";
import back_arrow from "../../assets/svg/back-arrow.svg";
import plus_icon from "../../assets/svg/plus_icon.svg";
import { useNavigate, useLocation } from "react-router-dom";
import axiosInstance from '../../axiosInstance';
import AsyncSelect from 'react-select/async';
import subcostlinearrow from "../../assets/svg/subCostline_arrow.svg"
import formula_icon from "../../assets/svg/formula-icon.svg"
import three_dots from "../../assets/svg/Dots.svg"
import { ToastContainer, toast } from "react-toastify"
import { PDFDownloadLink } from '@react-pdf/renderer';
import PdfGenerate from '../../ProjectCreation/PdfGenerate/PdfGenerate';
import CommonFooter from '../../CommonFooter/CommonFooter';
import { X } from 'lucide-react';
import delete_icon from "../../assets/svg/delete_icon.svg";
import ConfirmDialog from '../../ConfirmDialog/ConfirmDialog';
import { deleteElement } from "../../Redux/slices";

const CostLineCreate = () => {

    const selectedPeriodIndex = useSelector((state) => state.period.selectedPeriodIndex);
    const selectedCategoryIndex = useSelector((state) => state.period.selectedCategoryIndex);
    const location = useLocation();
    const isEditMode = location.state?.isEditMode;
    const costlineData = location.state?.costline_data;
    const costlineDataId = location.state?.costlineId;
    const [copiedData, setCopiedData] = useState(null);
    console.log("costlineDataId...", costlineDataId)
    const dispatch = useDispatch();
    const [showPopup, setShowPopup] = useState(false);
    const [editingIndex, setEditingIndex] = useState(null);
    const [editingData, setEditingData] = useState({});
    const [projectInput, setProjectInput] = useState("");
    const [projectId, setselectedprojectId] = useState(0);
    const [selectedproject, setselectedproject] = useState(0);
    const [activePeriod, setActivePeriod] = useState("Summary");
    const [showTemplateInput, setShowTemplateInput] = useState(false);
    const navigate = useNavigate();
    const [tooltip, setTooltip] = useState({ visible: false, content: '', position: { x: 0, y: 0 } });
    const periods = useSelector((state) => state.period.periods);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [financialRates, setFinancialRates] = useState([]);
    const [categories, setCategories] = useState([]);
    const [showTemplateConfirmation, setShowTemplateConfirmation] = useState(false);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [pendingDeleteIndex, setPendingDeleteIndex] = useState(null);
    const [showReuseTemplateConfirmation, setShowReuseTemplateConfirmation] = useState(false);
    const [mappedTemplateToReuse, setMappedTemplateToReuse] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [submitType, setSubmitType] = useState("save");
    const [activeRowContext, setActiveRowContext] = useState({ periodIndex: null, categoryIndex: null })

    const [copiedCategoryData, setCopiedCategoryData] = useState(() => {
        try {
            const stored = sessionStorage.getItem('costline_copiedCategoryData');
            return stored ? JSON.parse(stored) : null;
        } catch (err) {
            console.error('Failed to restore copied category data:', err);
            return null;
        }
    });
    const [categoryDropdownVisibleFor, setCategoryDropdownVisibleFor] = useState(null);

    const [selectedTemplateForConfirmation, setSelectedTemplateForConfirmation] = useState(null);
    const [formData, setFormData] = useState({
        project_id: '',
        project_name: '',
        model_id: '',
        model_name: '',
        business_unit: '',
        customer: '',
        project_description: '',
        templateName: ''
    });

    const [pdfProjectDetails, setPdfProjectDetails] = useState(null);

    useEffect(() => {
        const fetchProjectDetailsForPdf = async () => {
            if (formData.project_id) {
                try {
                    const projectRes = await axiosInstance.get(`/costsolution/costlines/getprojects/${formData.project_id}`);
                    setPdfProjectDetails(projectRes.data.projects);
                } catch (error) {
                    console.error("Error fetching project details for PDF:", error);
                }
            }
        };

        fetchProjectDetailsForPdf();
    }, [formData.project_id]);


    const FORMULAS = {
        WI_RATE: "WI Rate % = (Work Interest Rate) as defined in contract",
        COST_ESCALATION_PERCENTAGE: "Cost Escalation Percentage / Month",
        CAPEX_INTEREST_RATE: "Capex Interest Rate / Month ",
        CAPEX_MAINTENANCE: "Capex Maintenance / Month",
        CAPEX_INSURANCE: "Capex Insurance/ Month",
        BASIC_COST_VALUE: "(Quantity × Rate) / Cost period",
        COST_ESCALATION: "((Quantity × Rate) / Cost period) * (Cost escalation / 100)",
        CAPEX_COST_INTEREST: "Capex Cost Interest = (Capex × Interest Rate × Time) / 100",
        COST_MAINTENANCE: "((Quantity × Rate) * capex maintenance / 100)) / 12",
        COST_INSURANCE: "((Quantity × Rate) * capex maintenance / 100)) / 12",
        COST_BUFFER: "(Basic Cost Value + Cost Escalation + Cost Interest + Cost Maintenance + Cost Insurance)*(Buffer Rate / 100)",
        COST_MARGIN: "(Basic Cost Value + Cost Escalation + Cost Interest + Cost Maintenance + Cost Insurance + Cost Buffer) * ( Margin Rate / 100 )",
        COST_WI: "(Basic Cost Value + Cost Escalation + Cost Interest + Cost Maintenance + Cost Insurance + Cost Buffer ) * (WI Rate / 100)",
        COST_WITH_BUFFER_MONTH: "Basic Cost Value + Cost Escalation + Cost Interest + Cost Maintenance + Cost Insurance +Cost Buffer + Cost Margin",
        COST_WITHOUT_BUFFER_MONTH: "Basic Cost Value + Cost Escalation + Cost Interest + Cost Maintenance + Cost Insurance + Cost Margin",
        COST_WITH_BUFFER_PERIOD: "Cost with Buffer (month) * period",
        COST_WITHOUT_BUFFER_PERIOD: "Cost W/O Buffer (month) * period"
    };

    const handleTemplateChange = (selectedOption) => {
        if (selectedOption) {
            if (formData.model_id && selectedOption.model && formData.model_id != selectedOption.model) {
                toast.error(`The selected template's model (${selectedOption.modelCode || 'N/A'}) does not match the project's model (${formData.model_name || 'N/A'}).`);
                setSelectedTemplate(null);
                return;
            }

            setSelectedTemplateForConfirmation(selectedOption);
            setShowTemplateConfirmation(true);
        } else {
            setSelectedTemplate(null);
            const clearedPeriods = periods.map(period => ({
                ...period,
                categories: period.categories.map(category => ({
                    ...category,
                    elementlist: []
                }))
            }));
            dispatch(updatePeriods(clearedPeriods));
        }
    };

    const applyTemplateIdToGrid = async (templateId, templateLabel, templateModel, templateModelCode, targetPeriodId, basePeriods) => {
        try {
            const periodId = targetPeriodId || periods[selectedPeriodIndex]?.id;
            console.log("Selected Period ID:", periodId);

            let financialRatesData = [];
            try {
                const financialRes = await axiosInstance.get(`/costsolution/financial/project/${costlineDataId || projectId}`);
                if (financialRes.data.success) {
                    financialRatesData = financialRes.data.costescalation || [];
                }
            } catch (err) {
                console.error("Error fetching financial assumptions for grid template:", err);
            }

            const templateRes = await axiosInstance.get(
                `/costsolution/template/get/${templateId}?${periodId}`
            );

            const templateData = templateRes.data?.projecttemplate;
            console.log("Fetched Template Data:", templateData);

            if (templateData && templateData.templateProjects) {
                const categoryRes = await axiosInstance.get(
                    `/costsolution/costlines/getcategory/${costlineDataId || projectId}`
                );
                const existingCategories = categoryRes.data?.projectcategory || [];
                console.log("Existing Categories:", existingCategories);

                // 3. Create a deep copy of periods
                const updatedPeriods = JSON.parse(JSON.stringify(basePeriods || periods));
                const periodIdx = (selectedPeriodIndex !== null) ? selectedPeriodIndex : 0;

                // 4. Group template projects by their category
                const projectsByCategory = {};
                templateData.templateProjects.forEach(project => {
                    if (!projectsByCategory[project.categoryId]) {
                        projectsByCategory[project.categoryId] = [];
                    }
                    projectsByCategory[project.categoryId].push(project);
                });

                const mapProjectToElement = (project) => {
                    let quantitySetupRows = [];
                    if (project.quantitySetup) {
                        try {
                            quantitySetupRows = typeof project.quantitySetup === 'string'
                                ? JSON.parse(project.quantitySetup)
                                : project.quantitySetup;
                        } catch (e) {
                            console.error("Failed to parse quantitySetup:", e);
                        }
                    }
                    let rateSetupRows = [];
                    if (project.rateSetup) {
                        try {
                            rateSetupRows = typeof project.rateSetup === 'string'
                                ? JSON.parse(project.rateSetup)
                                : project.rateSetup;
                        } catch (e) {
                            console.error("Failed to parse rateSetup:", e);
                        }
                    }

                    const catRate = financialRatesData.find(r => r.category_id == project.categoryId || r.categoryId == project.categoryId);
                    const marginRateVal = (project.marginRate !== undefined && project.marginRate !== null && project.marginRate !== '')
                        ? project.marginRate.toString()
                        : (catRate ? (catRate.marginRate?.toString() || '0') : '0');
                    const wiRateVal = (project.wiRate !== undefined && project.wiRate !== null && project.wiRate !== '')
                        ? project.wiRate.toString()
                        : (catRate ? (catRate.wiRate?.toString() || '0') : '0');
                    const bufferRateVal = (project.bufferRate !== undefined && project.bufferRate !== null && project.bufferRate !== '')
                        ? project.bufferRate.toString()
                        : (catRate ? (catRate.bufferRate?.toString() || '0') : '0');
                    const costEscalationPercentageVal = (project.costEscalationPercentage !== undefined && project.costEscalationPercentage !== null && project.costEscalationPercentage !== '')
                        ? project.costEscalationPercentage.toString()
                        : (catRate ? (catRate.percentage?.toString() || '0') : '0');
                    const capexInterestRateVal = (project.interestRate !== undefined && project.interestRate !== null && project.interestRate !== '')
                        ? project.interestRate.toString()
                        : (catRate ? (catRate.interestPerMonth?.toString() || '0') : '0');
                    const capexInsuranceVal = (project.capexInsurance !== undefined && project.capexInsurance !== null && project.capexInsurance !== '')
                        ? project.capexInsurance.toString()
                        : (catRate ? (catRate.insurancePerMonth?.toString() || '0') : '0');

                    const periodMonth = updatedPeriods[periodIdx]?.month || '1';

                    return computeDerivedValues({
                        id: "0",
                        uiKey: Date.now() + Math.random(),
                        period: periodMonth,
                        element: project.costElementName || '',
                        element_remarks: project.elementRemarks || '',
                        cost_period: project.costPeriod || '1',
                        quantity: project.quantity || '0',
                        rate: project.rate || '0',
                        quantity_setup: quantitySetupRows,
                        rate_setup: rateSetupRows,
                        gross_value: project.basicCostValue || '0',
                        margin_rate_percentage: marginRateVal,
                        wi_rate: wiRateVal,
                        cost_escalation_percentage: costEscalationPercentageVal,
                        capex_maintenance: project.capexMaintenance || '0',
                        cost_insurance: project.costInsurance || '0',
                        cost_maintenance: project.costMaintenance || '0',
                        buffer_rate: bufferRateVal,
                        basic_cost_value: project.basicCostValue || '0',
                        cost_escalation: project.costEscalation || '0',
                        capex_cost_interest: project.costInterest || '0',
                        cost_margin: project.costMargin || '0',
                        cost_with_buffer_month: project.costValueWithBufferMonth || '0',
                        cost_buffer: project.costBuffer || '0',
                        cost_without_buffer_month: project.costValueWithoutBufferMonth || '0',
                        cost_with_buffer_period: project.costValueWithBufferPeriod || '0',
                        capex_interest_rate_percentage: capexInterestRateVal,
                        cost_without_buffer_period: project.costValueWithoutBufferPeriod || '0',
                        capex_insurance_percentage: capexInsuranceVal,
                        cost_wi: project.costWI || '0',
                        costElementId: project.costElementId || '',
                        costTypeId: project.costTypeId || ''
                    });
                };

                Object.entries(projectsByCategory).forEach(([categoryId, projects]) => {
                    const matchingCategory = existingCategories.find(
                        cat => cat.categoryId == categoryId
                    );

                    if (matchingCategory) {
                        const periodCategoryIndex = updatedPeriods[periodIdx].categories.findIndex(
                            cat => cat.id == categoryId
                        );

                        if (periodCategoryIndex !== -1) {
                            const newElements = projects.map(mapProjectToElement);
                            updatedPeriods[periodIdx].categories[periodCategoryIndex].elementlist = [
                                ...updatedPeriods[periodIdx].categories[periodCategoryIndex].elementlist,
                                ...newElements
                            ];
                        } else {
                            updatedPeriods[periodIdx].categories.push({
                                id: matchingCategory.categoryId,
                                name: matchingCategory.categoryName,
                                code: matchingCategory.categoryCode,
                                elementlist: projects.map(mapProjectToElement)
                            });
                        }
                    } else {
                        console.warn(`No matching category found for template category ID ${categoryId}`);
                    }
                });

                console.log("Updated Periods (before dispatch):", updatedPeriods);
                dispatch(updatePeriods(updatedPeriods));
                setSelectedTemplate({
                    value: templateId,
                    label: templateLabel,
                    model: templateModel,
                    modelCode: templateModelCode
                });
                toast.success("Template applied successfully!");
            } else {
                toast.warning("Template has no project data.");
            }
        } catch (error) {
            console.error("Error applying template:", error);
            toast.error("Failed to apply template");
        }
    };

    const handleTemplateProceed = async () => {
        if (!selectedTemplateForConfirmation) return;
        await applyTemplateIdToGrid(
            selectedTemplateForConfirmation.value,
            selectedTemplateForConfirmation.label,
            selectedTemplateForConfirmation.model,
            selectedTemplateForConfirmation.modelCode
        );
        setShowTemplateConfirmation(false);
        setSelectedTemplateForConfirmation(null);
    };

    const handleReuseTemplateProceed = async () => {
        if (!mappedTemplateToReuse) return;
        await applyTemplateIdToGrid(
            mappedTemplateToReuse.value,
            mappedTemplateToReuse.label,
            mappedTemplateToReuse.model,
            mappedTemplateToReuse.modelCode,
            mappedTemplateToReuse.periodId,
            mappedTemplateToReuse.periods
        );
        setShowReuseTemplateConfirmation(false);
    };

    const handleReuseTemplateCancel = () => {
        setShowReuseTemplateConfirmation(false);
        setSelectedTemplate(null);
    };

    const handleTemplateCancel = () => {
        setShowTemplateConfirmation(false);
        setSelectedTemplateForConfirmation(null);
    };

    const handleSubcostlineArrowClick = (e, field, element, subIndex) => {
        e.stopPropagation();

        sessionStorage.setItem('popupState', JSON.stringify({
            isOpen: true,
            editingIndex: subIndex,
            editingData: element
        }));


        const elementData = {
            ...element,
            [field === 'quantity' ? 'quantitySetup' : 'rateSetup']:
                field === 'quantity'
                    ? (element.quantity_setup || element.quantitySetup || [])
                    : (element.rate_setup || element.rateSetup || [])
        };

        const activeCategory = periods[selectedPeriodIndex]?.categories[selectedCategoryIndex];

        const navigationPayload = {
            field,
            element: elementData,
            existingRows: field === 'quantity'
                ? (element.quantity_setup || element.quantitySetup || [])
                : (element.rate_setup || element.rateSetup || []),
            rowType: location.state?.costlineId ? 'existing' : 'new',
            rowIdentifier: location.state?.costlineId || subIndex,
            periodIndex: selectedPeriodIndex,
            categoryIndex: selectedCategoryIndex,
            categoryId: activeCategory?.id,
            elementUiKey: element.uiKey ?? null,
            elementIndex: subIndex,
            projectData: {
                id: formData.project_id,
                project: formData.project_name,
                scope: formData.business_unit,
                customerContactName: formData.customer,
                modelId: formData.model_id,
                modelCode: formData.model_name
            },
        };

        sessionStorage.setItem('subcostNavigationData', JSON.stringify(navigationPayload));
        sessionStorage.setItem('subcostFlowActive', 'true');
        navigate('/subcostline');
    };

    useEffect(() => {
        const handleReturnFromSubcost = () => {
            const returnData = sessionStorage.getItem("subcostReturnData");
            if (!returnData) return;

            try {
                const parsedData = JSON.parse(returnData);
                console.log("🔄 RETURNED DATA:", parsedData);

                if (parsedData.projectData) {
                    setFormData(prev => ({
                        ...prev,
                        project_id: parsedData.projectData.id || prev.project_id,
                        project_name: parsedData.projectData.project || prev.project_name,
                        model_id: parsedData.projectData.modelId || prev.model_id,
                        model_name: parsedData.projectData.modelCode || prev.model_name,
                        business_unit: parsedData.projectData.scope || prev.business_unit,
                        customer: parsedData.projectData.customerContactName || prev.customer
                    }));
                }

                const resolvedCategoryIndex = parsedData.categoryId
                    ? periods[parsedData.periodIndex]?.categories?.findIndex(c => c.id === parsedData.categoryId)
                    : parsedData.categoryIndex;

                if (
                    parsedData.periodIndex !== undefined &&
                    resolvedCategoryIndex !== undefined &&
                    resolvedCategoryIndex !== -1 &&
                    periods[parsedData.periodIndex]?.categories?.[resolvedCategoryIndex]
                ) {
                    const updatedElement = {
                        ...parsedData.element,
                        [parsedData.field]: parsedData.calculatedValue,
                        [parsedData.field === "quantity" ? "quantity_setup" : "rate_setup"]: parsedData.rows
                    };

                    const tempData = {
                        ...updatedElement,
                        [parsedData.field]: parsedData.calculatedValue
                    };

                    const quantity = parseFloat(parsedData.field === 'quantity' ? parsedData.calculatedValue : tempData.quantity) || 0;
                    const rate = parseFloat(parsedData.field === 'rate' ? parsedData.calculatedValue : tempData.rate) || 0;
                    const bufferRate = parseFloat(tempData.buffer_rate || 0);
                    const marginRate = parseFloat(tempData.margin_rate_percentage || 0);
                    const wiRate = parseFloat(tempData.wi_rate || 0);
                    const costEscalationPercentage = parseFloat(tempData.cost_escalation_percentage || 0);
                    const capexInterestRate = parseFloat(tempData.capex_interest_rate_percentage || 0);
                    const capexMaintenanceRate = parseFloat(tempData.capex_maintenance || 0);
                    const capexInsuranceRate = parseFloat(tempData.capex_insurance_percentage || 0);
                    const costPeriod = parseFloat(tempData.cost_period || 1);
                    const period = parseFloat(tempData.period || 1);

                    const grossValue = quantity * rate;
                    const basicCostValue = grossValue / costPeriod;
                    const costEscalation = basicCostValue * (costEscalationPercentage / 100);
                    const capexCostInterest = (grossValue * capexInterestRate * 1) / 100;
                    const costMaintenance = (grossValue * capexMaintenanceRate / 100) / 12;
                    const costInsurance = (grossValue * capexInsuranceRate / 100) / 12;
                    const costBuffer = (basicCostValue + costEscalation + capexCostInterest + costMaintenance + costInsurance) * (bufferRate / 100);
                    const costMargin = (basicCostValue + costEscalation + capexCostInterest + costMaintenance + costInsurance + costBuffer) * (marginRate / 100);
                    const costWI = (basicCostValue + costEscalation + capexCostInterest + costMaintenance + costInsurance + costBuffer) * (wiRate / 100);
                    const costWithBufferMonth = basicCostValue + costEscalation + capexCostInterest + costMaintenance + costInsurance + costBuffer + costMargin;
                    const costWithoutBufferMonth = basicCostValue + costEscalation + capexCostInterest + costMaintenance + costInsurance + costMargin;
                    const costWithBufferPeriod = costWithBufferMonth * period;
                    const costWithoutBufferPeriod = costWithoutBufferMonth * period;

                    const fullyUpdatedElement = {
                        ...updatedElement,
                        gross_value: grossValue.toFixed(2),
                        basic_cost_value: basicCostValue.toFixed(2),
                        cost_escalation: costEscalation.toFixed(2),
                        capex_cost_interest: capexCostInterest.toFixed(2),
                        cost_maintenance: costMaintenance.toFixed(2),
                        cost_insurance: costInsurance.toFixed(2),
                        cost_buffer: costBuffer.toFixed(2),
                        cost_margin: costMargin.toFixed(2),
                        cost_wi: costWI.toFixed(2),
                        cost_with_buffer_month: costWithBufferMonth.toFixed(2),
                        cost_without_buffer_month: costWithoutBufferMonth.toFixed(2),
                        cost_with_buffer_period: costWithBufferPeriod.toFixed(2),
                        cost_without_buffer_period: costWithoutBufferPeriod.toFixed(2)
                    };

                    dispatch(
                        updateElement({
                            periodIndex: parsedData.periodIndex,
                            categoryIndex: resolvedCategoryIndex,
                            elementIndex: parsedData.elementIndex,
                            element: fullyUpdatedElement,
                        })
                    );

                    const popupState = JSON.parse(sessionStorage.getItem("popupState"));
                    if (popupState?.isOpen) {
                        setActivePeriod(`Period ${parsedData.periodIndex + 1}`);
                        dispatch(selectPeriod(parsedData.periodIndex));
                        dispatch(selectCategory(resolvedCategoryIndex));
                        setEditingIndex(popupState.editingIndex);
                        setEditingData(fullyUpdatedElement);
                        setShowPopup(true);
                    }
                }

                sessionStorage.removeItem("subcostReturnData");
                sessionStorage.removeItem("popupState");
                sessionStorage.removeItem("subcostFlowActive");
            } catch (error) {
                console.error("Failed to process return data:", error);
            }
        };

        const timer = setTimeout(() => {
            handleReturnFromSubcost();
        }, 300);

        return () => clearTimeout(timer);
    }, [dispatch, periods]);


    const handleFormulaHover = (content, e) => {
        const tooltipWidth = 300;
        const tooltipHeight = 150;
        const offset = 10;

        let x = e.clientX;
        let y = e.clientY;

        if (x + tooltipWidth + offset > window.innerWidth) {
            x = window.innerWidth - tooltipWidth - offset;
        }

        if (y + tooltipHeight + offset > window.innerHeight) {
            y = window.innerHeight - tooltipHeight - offset;
        }

        setTooltip({
            visible: true,
            content,
            position: { x, y }
        });
    };

    const handleFormulaLeave = () => {
        setTooltip({ ...tooltip, visible: false });
    };

    const PeriodTabs = () => {
        const periodTabs = ["Summary", ...periods.map((_, index) => `Period ${index + 1}`)];
        const [dropdownVisibleFor, setDropdownVisibleFor] = useState(null);

        // useEffect(() => {
        //     if (periods.length > 0 && !periodTabs.includes(activePeriod)) {
        //         setActivePeriod(`Period 1`);
        //         dispatch(selectPeriod(0));
        //     }
        // }, [periods]);

        const toggleDropdown = (period) => {
            setDropdownVisibleFor(dropdownVisibleFor === period ? null : period);
        };

        const handleCopy = (periodIndex) => {
            const periodData = periods[periodIndex];
            setCopiedData(periodData);
            setDropdownVisibleFor(null);
            toast.success("Copied period data!");
        };

        const handlePaste = (targetPeriodIndex) => {
            if (!copiedData) {
                toast.error("No data copied to paste!");
                return;
            }

            const updatedPeriods = JSON.parse(JSON.stringify(periods));

            copiedData.categories.forEach(copiedCategory => {
                const targetCategoryIndex = updatedPeriods[targetPeriodIndex].categories.findIndex(
                    cat => cat.name === copiedCategory.name
                );

                if (targetCategoryIndex !== -1) {
                    const targetCategory = updatedPeriods[targetPeriodIndex].categories[targetCategoryIndex];
                    targetCategory.elementlist = [
                        ...targetCategory.elementlist,
                        ...copiedCategory.elementlist.map(el => ({ ...el }))
                    ];
                } else {
                    updatedPeriods[targetPeriodIndex].categories.push({
                        ...copiedCategory,
                        elementlist: copiedCategory.elementlist.map(el => ({ ...el }))
                    });
                }
            });

            dispatch(updatePeriods(updatedPeriods));
            setDropdownVisibleFor(null);
            toast.success("Pasted data to period!");
        };

        return (
            <div className="period-tabs">
                {periodTabs.map((period, index) => (
                    <span key={period} style={{ display: 'flex', alignItems: 'center' }}>
                        <button
                            className={`tab ${(period === "Summary" && activePeriod === "Summary") ||
                                (period !== "Summary" && activePeriod === period)
                                ? "active"
                                : ""
                                }`}
                            onClick={() => {
                                if (period === "Summary") {
                                    setActivePeriod("Summary");
                                    dispatch(selectPeriod(null));
                                } else {
                                    setActivePeriod(period);
                                    dispatch(selectPeriod(index - 1));
                                }
                            }}
                        >
                            {period}
                        </button>
                        {period.startsWith("Period") && (
                            <div className="three-dots-menu">
                                <img
                                    className="three-dots-periods"
                                    src={three_dots}
                                    alt="options"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleDropdown(period);
                                    }}
                                />
                                {dropdownVisibleFor === period && (
                                    <div className="dots-dropdown-menu">
                                        <button onClick={(e) => {
                                            e.stopPropagation();
                                            handleCopy(index - 1);
                                        }}>➤ Copy</button>
                                        <button onClick={(e) => {
                                            e.stopPropagation();
                                            handlePaste(index - 1);
                                        }}>➤ Paste</button>
                                    </div>
                                )}
                            </div>
                        )}
                    </span>
                ))}
            </div>
        );
    };

    const summaryData = {
        withBufferMonth: {
            rows: periods[0]?.categories.map(category => {
                const periodValues = {};
                periods.forEach((_, idx) => {
                    periodValues[`period${idx + 1}`] = 0;
                });

                periods.forEach((period, periodIdx) => {
                    const categoryInPeriod = period.categories.find(c => c.id === category.id);
                    if (categoryInPeriod) {
                        periodValues[`period${periodIdx + 1}`] =
                            categoryInPeriod.elementlist.reduce((sum, element) => {
                                return sum + parseFloat(element.cost_with_buffer_month || 0);
                            }, 0).toFixed(2);
                    }
                });

                const total = Object.values(periodValues).reduce((sum, val) =>
                    sum + parseFloat(val || 0), 0).toFixed(2);

                return {
                    subcategory: category.name,
                    ...periodValues,
                    total
                };
            }) || []
        },
        withoutBufferMonth: {
            rows: periods[0]?.categories.map(category => {
                const periodValues = {};
                periods.forEach((_, idx) => {
                    periodValues[`period${idx + 1}`] = 0;
                });

                periods.forEach((period, periodIdx) => {
                    const categoryInPeriod = period.categories.find(c => c.id === category.id);
                    if (categoryInPeriod) {
                        periodValues[`period${periodIdx + 1}`] =
                            categoryInPeriod.elementlist.reduce((sum, element) => {
                                return sum + parseFloat(element.cost_without_buffer_month || 0);
                            }, 0).toFixed(2);
                    }
                });

                const total = Object.values(periodValues).reduce((sum, val) =>
                    sum + parseFloat(val || 0), 0).toFixed(2);

                return {
                    subcategory: category.name,
                    ...periodValues,
                    total
                };
            }) || []
        },
        withBufferPeriod: {
            rows: periods[0]?.categories.map(category => {
                const periodValues = {};
                periods.forEach((_, idx) => {
                    periodValues[`period${idx + 1}`] = 0;
                });

                periods.forEach((period, periodIdx) => {
                    const categoryInPeriod = period.categories.find(c => c.id === category.id);
                    if (categoryInPeriod) {
                        periodValues[`period${periodIdx + 1}`] =
                            categoryInPeriod.elementlist.reduce((sum, element) => {
                                return sum + parseFloat(element.cost_with_buffer_period || 0);
                            }, 0).toFixed(2);
                    }
                });

                const total = Object.values(periodValues).reduce((sum, val) =>
                    sum + parseFloat(val || 0), 0).toFixed(2);

                return {
                    subcategory: category.name,
                    ...periodValues,
                    total
                };
            }) || []
        },
        withoutBufferPeriod: {
            rows: periods[0]?.categories.map(category => {
                const periodValues = {};
                periods.forEach((_, idx) => {
                    periodValues[`period${idx + 1}`] = 0;
                });

                periods.forEach((period, periodIdx) => {
                    const categoryInPeriod = period.categories.find(c => c.id === category.id);
                    if (categoryInPeriod) {
                        periodValues[`period${periodIdx + 1}`] =
                            categoryInPeriod.elementlist.reduce((sum, element) => {
                                return sum + parseFloat(element.cost_without_buffer_period || 0);
                            }, 0).toFixed(2);
                    }
                });

                const total = Object.values(periodValues).reduce((sum, val) =>
                    sum + parseFloat(val || 0), 0).toFixed(2);

                return {
                    subcategory: category.name,
                    ...periodValues,
                    total
                };
            }) || []
        }
    };

    const CostTable = ({ data, title, periods }) => {
        const periodTotals = {};

        periods.forEach((_, index) => {
            periodTotals[`period${index + 1}`] = 0;
        });
        periodTotals.total = 0;

        data.rows.forEach(row => {
            periods.forEach((_, index) => {
                periodTotals[`period${index + 1}`] += parseFloat(row[`period${index + 1}`] || 0);
            });
            periodTotals.total += parseFloat(row.total || 0);
        });

        return (
            <div className="cost-table-container">
                <div className="category-header">
                    <span>{title}</span>
                </div>
                <table className="cost-table">
                    <thead>
                        <tr>
                            <th className="subcategory-header">Category</th>
                            {periods.map((period, index) => (
                                <th key={`period-${index}`}>Period {index + 1}</th>
                            ))}
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.rows.map((row, index) => (
                            <tr key={index}>
                                <td className="subcategory-cell">{row.subcategory}</td>
                                {periods.map((_, periodIndex) => (
                                    <td key={`value-${periodIndex}`}>
                                        {parseFloat(row[`period${periodIndex + 1}`]).toLocaleString()}
                                    </td>
                                ))}
                                <td>{parseFloat(row.total).toLocaleString()}</td>
                            </tr>
                        ))}
                        <tr className="grand-total-row">
                            <td>Grand Total</td>
                            {periods.map((_, index) => (
                                <td key={`total-${index}`}>
                                    {periodTotals[`period${index + 1}`].toLocaleString()}
                                </td>
                            ))}
                            <td>{periodTotals.total.toLocaleString()}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    };

    const CostComparisonTable = ({ withData, withoutData, title, periods }) => {
        const withTotals = {};
        const withoutTotals = {};

        periods.forEach((_, index) => {
            withTotals[`period${index + 1}`] = 0;
            withoutTotals[`period${index + 1}`] = 0;
        });
        withTotals.total = 0;
        withoutTotals.total = 0;

        withData.rows.forEach(row => {
            periods.forEach((_, index) => {
                withTotals[`period${index + 1}`] += parseFloat(row[`period${index + 1}`] || 0);
            });
            withTotals.total += parseFloat(row.total || 0);
        });

        withoutData.rows.forEach(row => {
            periods.forEach((_, index) => {
                withoutTotals[`period${index + 1}`] += parseFloat(row[`period${index + 1}`] || 0);
            });
            withoutTotals.total += parseFloat(row.total || 0);
        });

        return (
            <div className="cost-table-container">
                <div className="category-header">
                    <span>{title}</span>
                </div>
                <table className="cost-table">
                    <thead>
                        <tr>
                            <th className="subcategory-header">Category</th>
                            {periods.map((period, index) => (
                                <th key={`period-${index}`} colSpan="2">Period {index + 1}</th>
                            ))}
                            <th colSpan="2">Total</th>
                        </tr>
                        <tr>
                            <th></th>
                            {periods.map((_, index) => (
                                <>
                                    <th key={`with-${index}`}>With Buffer</th>
                                    <th key={`without-${index}`}>Without Buffer</th>
                                </>
                            ))}
                            <th>With Buffer</th>
                            <th>Without Buffer</th>
                        </tr>
                    </thead>
                    <tbody>
                        {withData.rows.map((row, index) => (
                            <tr key={index}>
                                <td className="subcategory-cell">{row.subcategory}</td>
                                {periods.map((_, periodIndex) => (
                                    <>
                                        <td key={`with-val-${periodIndex}`}>
                                            {parseFloat(row[`period${periodIndex + 1}`]).toLocaleString()}
                                        </td>
                                        <td key={`without-val-${periodIndex}`}>
                                            {parseFloat(withoutData.rows[index]?.[`period${periodIndex + 1}`] || 0).toLocaleString()}
                                        </td>
                                    </>
                                ))}
                                <td>{parseFloat(row.total).toLocaleString()}</td>
                                <td>{parseFloat(withoutData.rows[index]?.total || 0).toLocaleString()}</td>
                            </tr>
                        ))}
                        <tr className="grand-total-row">
                            <td>Grand Total</td>
                            {periods.map((_, index) => (
                                <>
                                    <td key={`with-total-${index}`}>
                                        {withTotals[`period${index + 1}`].toLocaleString()}
                                    </td>
                                    <td key={`without-total-${index}`}>
                                        {withoutTotals[`period${index + 1}`].toLocaleString()}
                                    </td>
                                </>
                            ))}
                            <td>{withTotals.total.toLocaleString()}</td>
                            <td>{withoutTotals.total.toLocaleString()}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    };

    const togglePopup = (index = null, element = null) => {
        if (index !== null) {
            setEditingIndex(index);
            setActiveRowContext({
                periodIndex: selectedPeriodIndex,
                categoryIndex: selectedCategoryIndex
            });
            const periodMonth = periods[selectedPeriodIndex]?.month || '';
            setEditingData(computeDerivedValues({ ...element, period: periodMonth }));
        }
        setShowPopup(!showPopup);
    };

    const handleAddRow = () => {
        if (selectedPeriodIndex !== null && selectedCategoryIndex !== null &&
            periods.length > selectedPeriodIndex &&
            periods[selectedPeriodIndex]?.categories?.length > selectedCategoryIndex) {

            const activeCategory = periods[selectedPeriodIndex]?.categories[selectedCategoryIndex];
            const catId = activeCategory?.id || activeCategory?.categoryId;
            const catRate = financialRates.find(r => r.category_id == catId || r.categoryId == catId);

            const periodMonth = periods[selectedPeriodIndex]?.month || '1';

            const newElement = computeDerivedValues({
                period: periodMonth,
                element: "",
                cost_period: "",
                element_remarks: "",
                quantity: "",
                quantity_setup: "",
                rate: "",
                rate_setup: "",
                cost_maintenance: "",
                wi_rate: catRate ? (catRate.wiRate?.toString() || "0") : "",
                cost_margin: "",
                cost_escalation_percentage: catRate ? (catRate.percentage?.toString() || "0") : "",
                cost_escalation: "",
                margin_rate_percentage: catRate ? (catRate.marginRate?.toString() || "0") : "",
                cost_with_buffer_month: "",
                capex_maintenance: "",
                cost_buffer: "",
                basic_cost_value: "",
                cost_without_buffer_month: "",
                buffer_rate: catRate ? (catRate.bufferRate?.toString() || "0") : "",
                gross_value: "",
                capex_cost_interest: "",
                cost_with_buffer_period: "",
                capex_interest_rate_percentage: catRate ? (catRate.interestPerMonth?.toString() || "0") : "",
                cost_insurance: "",
                cost_without_buffer_period: "",
                capex_insurance_percentage: catRate ? (catRate.insurancePerMonth?.toString() || "0") : "",
                cost_wi: ""
            });

            dispatch(addElement({
                periodIndex: selectedPeriodIndex,
                categoryIndex: selectedCategoryIndex,
                element: newElement
            }));
        } else {
            console.error("Cannot add row - missing required indices or data");
        }
    };

    const handleInputChange = (e, field) => {
        let value = e.target.value;
        if (NUMERIC_ONLY_FIELDS.has(field)) {
            value = sanitizeNumericInput(value);
        }
        const updatedData = { ...editingData, [field]: value };

        if (field === 'quantity' || field === 'rate') {
            recalculateAllValues(updatedData);
        } else {
            const calculationFields = [
                'cost_period', 'buffer_rate', 'margin_rate_percentage', 'wi_rate',
                'cost_escalation_percentage', 'capex_interest_rate_percentage',
                'capex_maintenance', 'capex_insurance_percentage', 'period'
            ];
            if (calculationFields.includes(field)) {
                recalculateAllValues(updatedData);
            } else {
                setEditingData(updatedData);
            }
        }
    };

    const computeDerivedValues = (data) => {
        const quantity = parseFloat(data.quantity || 0);
        const rate = parseFloat(data.rate || 0);
        const bufferRate = parseFloat(data.buffer_rate || 0);
        const marginRate = parseFloat(data.margin_rate_percentage || 0);
        const wiRate = parseFloat(data.wi_rate || 0);
        const costEscalationPercentage = parseFloat(data.cost_escalation_percentage || 0);
        const capexInterestRate = parseFloat(data.capex_interest_rate_percentage || 0);
        const capexMaintenanceRate = parseFloat(data.capex_maintenance || 0);
        const capexInsuranceRate = parseFloat(data.capex_insurance_percentage || 0);
        const costPeriod = parseFloat(data.cost_period || 1);
        const period = parseFloat(data.period || 1);

        const grossValue = quantity * rate;
        const basicCostValue = grossValue / costPeriod;
        const costEscalation = basicCostValue * (costEscalationPercentage / 100);
        const capexCostInterest = (grossValue * capexInterestRate * 1) / 100;
        const costMaintenance = (grossValue * capexMaintenanceRate / 100) / 12;
        const costInsurance = (grossValue * capexInsuranceRate / 100) / 12;
        const costBuffer = (basicCostValue + costEscalation + capexCostInterest + costMaintenance + costInsurance) * (bufferRate / 100);
        const costMargin = (basicCostValue + costEscalation + capexCostInterest + costMaintenance + costInsurance + costBuffer) * (marginRate / 100);
        const costWI = (basicCostValue + costEscalation + capexCostInterest + costMaintenance + costInsurance + costBuffer) * (wiRate / 100);
        const costWithBufferMonth = basicCostValue + costEscalation + capexCostInterest + costMaintenance + costInsurance + costBuffer + costMargin;
        const costWithoutBufferMonth = basicCostValue + costEscalation + capexCostInterest + costMaintenance + costInsurance + costMargin;
        const costWithBufferPeriod = costWithBufferMonth * period;
        const costWithoutBufferPeriod = costWithoutBufferMonth * period;

        return {
            ...data,
            gross_value: grossValue.toFixed(2),
            basic_cost_value: basicCostValue.toFixed(2),
            cost_escalation: costEscalation.toFixed(2),
            capex_cost_interest: capexCostInterest.toFixed(2),
            cost_maintenance: costMaintenance.toFixed(2),
            cost_insurance: costInsurance.toFixed(2),
            cost_buffer: costBuffer.toFixed(2),
            cost_margin: costMargin.toFixed(2),
            cost_wi: costWI.toFixed(2),
            cost_with_buffer_month: costWithBufferMonth.toFixed(2),
            cost_without_buffer_month: costWithoutBufferMonth.toFixed(2),
            cost_with_buffer_period: costWithBufferPeriod.toFixed(2),
            cost_without_buffer_period: costWithoutBufferPeriod.toFixed(2)
        };
    };

    const recalculateAllValues = (data) => {
        setEditingData(computeDerivedValues(data));
    };

    const getOrdinal = (n) => {
        const s = ["th", "st", "nd", "rd"],
            v = n % 100;
        return n + (s[(v - 20) % 10] || s[v] || s[0]);
    };

    const handleSave = () => {
        if (!validateRowMandatoryFields(editingData)) return;
        const { periodIndex, categoryIndex } = activeRowContext;
        if (periodIndex !== null && categoryIndex !== null && editingIndex !== null) {
            dispatch(updateElement({
                periodIndex,
                categoryIndex,
                elementIndex: editingIndex,
                element: editingData
            }));
        }
        setShowPopup(false);
    };

    const loadProjectOptions = async (inputValue, callback) => {
        console.log("Searching for projects with:", inputValue);

        try {
            const res = await axiosInstance.get(
                "/costsolution/projects/autosuggestion",
                {
                    params: { term: inputValue || '' },
                    headers: { "Content-Type": "application/json" },
                }
            );

            const projects = res.data?.autosuggestion || [];

            const mapped = projects.map((item) => ({
                label: item.label,
                value: item.value,
            }));

            console.log("Filtered + Mapped project options:", mapped);
            callback(mapped);
        } catch (error) {
            console.error("Project suggestion error:", error);
            callback([]);
        }
    };

    const fetchProjectDetails = async (projectId) => {
        try {
            const projectRes = await axiosInstance.get(`/costsolution/costlines/getprojects/${projectId}`);
            const projectData = projectRes.data.projects;
            if (projectData && (projectData.projectPeriod === null || projectData.projectPeriod === undefined)) {
                toast.error("Please configure the project period in the project module first.");
                setProjectInput('');
                setFormData({
                    project_id: '',
                    project_name: '',
                    model_id: '',
                    model_name: '',
                    business_unit: '',
                    customer: '',
                    project_description: '',
                    templateName: ''
                });
                setselectedproject('');
                setselectedprojectId('');
                setShowTemplateInput(false);
                setSelectedTemplate(null);
                setShowReuseTemplateConfirmation(false);
                setMappedTemplateToReuse(null);
                return;
            }

            if (projectData) {
                setFormData(prev => ({
                    ...prev,
                    project_id: projectData.id ?? '0',
                    project_name: projectData.project ?? '',
                    business_unit: projectData.scope,
                    customer: projectData.customerContactName,
                    model_id: projectData.modelId,
                    model_name: projectData.modelCode
                }));
            }
            let financialRatesData = [];
            try {
                const financialRes = await axiosInstance.get(`/costsolution/financial/project/${projectId}`);
                if (financialRes.data.success) {
                    financialRatesData = financialRes.data.costescalation || [];
                }
            } catch (err) {
                console.error("Error fetching financial assumptions for project:", err);
            }
            setFinancialRates(financialRatesData);

            const periodRes = await axiosInstance.get(`/costsolution/costlines/getperiods/${projectId}`);
            const periodsData = periodRes.data.ProjectPeriod || [];

            const categoryRes = await axiosInstance.get(`/costsolution/costlines/getcategory/${projectId}`);
            const categoriesData = categoryRes.data.projectcategory || [];
            if (periodsData.length !== 0) {
                // Deduplicate categories by categoryId
                const uniqueCategories = [];
                const seenCategories = new Set();
                categoriesData.forEach(category => {
                    if (!seenCategories.has(category.categoryId)) {
                        seenCategories.add(category.categoryId);
                        uniqueCategories.push(category);
                    }
                });

                const reduxPeriods = periodsData.map(period => ({
                    id: period.id,
                    month: period.month,
                    categories: uniqueCategories.map(category => ({
                        id: category.categoryId,
                        name: category.categoryName,
                        elementlist: []
                    }))
                }));
                console.log("Redux Periods", reduxPeriods);

                dispatch(setPeriods(reduxPeriods));
                if (reduxPeriods.length > 0) {
                    setActivePeriod("Period 1");
                    dispatch(selectPeriod(0));
                    if (reduxPeriods[0].categories.length > 0) {
                        dispatch(selectCategory(0));
                    }
                }

                if (projectData && projectData.templateId) {
                    setMappedTemplateToReuse({
                        value: projectData.templateId,
                        label: projectData.templateName,
                        model: projectData.modelId,
                        modelCode: projectData.modelCode,
                        periodId: periodsData[0]?.id,
                        periods: reduxPeriods
                    });
                    setShowReuseTemplateConfirmation(true);
                } else {
                    setSelectedTemplate(null);
                    setShowReuseTemplateConfirmation(false);
                }
            }

        } catch (error) {
            console.error("Error fetching project-related data:", error);
        }
    };

    const tooltipStyle = {
        position: 'fixed',
        fontSize: '12px',
        left: `${tooltip.position.x}px`,
        top: `${tooltip.position.y}px`,
        backgroundColor: '#2d3748',
        color: '#fff',
        borderRadius: '4px',
        padding: '8px 12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
        zIndex: 9999,
        display: tooltip.visible ? 'block' : 'none',
        pointerEvents: 'none',
        maxWidth: '300px',
        whiteSpace: 'pre-wrap',
        lineHeight: '1.4',
    };

    useEffect(() => {
        const loadEditModeData = async () => {
            if (!isEditMode || !costlineData) return;

            const isReturningFromSubcost = sessionStorage.getItem('subcostFlowActive') === 'true';
            if (isReturningFromSubcost) {
                return;
            }

            console.log("costlineData..........", costlineData);
            setFormData({
                project_id: costlineData.projectId || '',
                project_name: costlineData.projectCode || '',
                model_id: costlineData.modelId || '',
                model_name: costlineData.modelCode || '',
                project_description: costlineData.projectDescription || '',
                business_unit: '',
                customer: ''
            });

            try {
                const [periodRes, categoryRes, structureRes, financialRes] = await Promise.all([
                    axiosInstance.get(`/costsolution/costlines/getperiods/${costlineData.projectId}`),
                    axiosInstance.get(`/costsolution/costlines/getcategory/${costlineData.projectId}`),
                    axiosInstance.get(`/costsolution/costlinestructures/${costlineDataId}`),
                    axiosInstance.get(`/costsolution/financial/project/${costlineData.projectId}`).catch(() => ({ data: { success: false } }))
                ]);

                const periodsData = periodRes.data?.ProjectPeriod || [];
                const categoriesDataRaw = categoryRes.data?.projectcategory || [];
                const structureData = structureRes.data?.costlinestructure || [];
                let financialRatesData = [];
                if (financialRes && financialRes.data?.success) {
                    financialRatesData = financialRes.data.costescalation || [];
                }
                setFinancialRates(financialRatesData);

                // Deduplicate categories by categoryId (same pattern as fetchProjectDetails)
                const uniqueCategories = [];
                const seenCategories = new Set();
                categoriesDataRaw.forEach(category => {
                    if (!seenCategories.has(category.categoryId)) {
                        seenCategories.add(category.categoryId);
                        uniqueCategories.push(category);
                    }
                });

                if (periodsData.length === 0) {
                    console.warn("No periods found for this project/costline.");
                    dispatch(setPeriods([]));
                    return;
                }

                const periodMap = new Map();
                periodsData.forEach(period => {
                    periodMap.set(String(period.id), {
                        id: period.id,
                        tag: period.tag,
                        month: period.month,
                        categories: new Map(
                            uniqueCategories.map(cat => [
                                cat.categoryId,
                                {
                                    id: cat.categoryId,
                                    name: cat.categoryName,
                                    code: cat.categoryCode,
                                    elementlist: []
                                }
                            ])
                        )
                    });
                });

                structureData.forEach(element => {
                    const periodId = String(element.projectPeriod);
                    const categoryId = element.categoryId;

                    if (periodMap.has(periodId) && periodMap.get(periodId).categories.has(categoryId)) {
                        const category = periodMap.get(periodId).categories.get(categoryId);

                        const periodObj = periodMap.get(periodId);
                        const periodMonth = periodObj?.month || '1';

                        const catRate = financialRatesData.find(r => r.category_id == categoryId || r.categoryId == categoryId);
                        const marginRateVal = (element.marginRate !== undefined && element.marginRate !== null && element.marginRate !== '')
                            ? element.marginRate.toString()
                            : (catRate ? (catRate.marginRate?.toString() || '0') : '0');
                        const wiRateVal = (element.wiRate !== undefined && element.wiRate !== null && element.wiRate !== '')
                            ? element.wiRate.toString()
                            : (catRate ? (catRate.wiRate?.toString() || '0') : '0');
                        const bufferRateVal = (element.bufferRate !== undefined && element.bufferRate !== null && element.bufferRate !== '')
                            ? element.bufferRate.toString()
                            : (catRate ? (catRate.bufferRate?.toString() || '0') : '0');
                        const costEscalationPercentageVal = (element.costEscalationPercentage !== undefined && element.costEscalationPercentage !== null && element.costEscalationPercentage !== '')
                            ? element.costEscalationPercentage.toString()
                            : (catRate ? (catRate.percentage?.toString() || '0') : '0');
                        const capexInterestRateVal = (element.interestRate !== undefined && element.interestRate !== null && element.interestRate !== '')
                            ? element.interestRate.toString()
                            : (catRate ? (catRate.interestPerMonth?.toString() || '0') : '0');
                        const capexInsuranceVal = (element.capexInsurance !== undefined && element.capexInsurance !== null && element.capexInsurance !== '')
                            ? element.capexInsurance.toString()
                            : (catRate ? (catRate.insurancePerMonth?.toString() || '0') : '0');

                        category.elementlist.push(computeDerivedValues({
                            id: element.id,
                            period: periodMonth,
                            element: element.costElementName || element.elementCode || '',
                            element_remarks: element.elementRemarks || '',
                            cost_period: element.costPeriod || '1',
                            quantity: element.quantity || '0',
                            rate: element.rate || '0',
                            quantity_setup: element.quantitySetup ? JSON.parse(element.quantitySetup) : "",
                            rate_setup: element.rateSetup ? JSON.parse(element.rateSetup) : "",
                            margin_rate_percentage: marginRateVal,
                            wi_rate: wiRateVal,
                            cost_escalation_percentage: costEscalationPercentageVal,
                            capex_maintenance: element.capexMaintenance || '0',
                            buffer_rate: bufferRateVal,
                            capex_interest_rate_percentage: capexInterestRateVal,
                            capex_insurance_percentage: capexInsuranceVal,
                            costElementId: element.costElementId || '',
                            costTypeId: element.costTypeId || ''
                        }));
                    }
                });

                const reduxPeriods = Array.from(periodMap.values()).map(period => ({
                    id: period.id,
                    tag: period.tag,
                    month: period.month,
                    categories: Array.from(period.categories.values())
                }));

                dispatch(setPeriods(reduxPeriods));

                if (reduxPeriods.length > 0) {
                    setActivePeriod("Period 1");
                    dispatch(selectPeriod(0));
                    if (reduxPeriods[0].categories.length > 0) {
                        dispatch(selectCategory(0));
                    }
                }
            } catch (error) {
                console.error("Failed to load edit-mode cost line data:", error);
                toast.error("Failed to load cost line details");
            }
        };

        loadEditModeData();
    }, [isEditMode, costlineData, costlineDataId, dispatch]);

    const loadCostElementOptions = async (inputValue, callback) => {
        try {
            const categoryId = selectedCategoryIndex !== null &&
                periods[selectedPeriodIndex]?.categories?.[selectedCategoryIndex]?.id;

            if (!categoryId) {
                callback([]);
                return;
            }

            const res = await axiosInstance.get(
                `/costsolution/costelement/autosuggestion/${categoryId}`,
                { params: { term: inputValue || '' } }
            );

            const costelement = res.data?.autosuggestion || [];
            const mapped = costelement.map((item) => ({
                label: item.code ? `${item.code} - ${item.label}` : item.label,
                value: item.value,
                code: item.code || ''
            }));

            callback(mapped);
        } catch (error) {
            console.error("Cost element suggestion error:", error);
            callback([]);
        }
    };

    const loadTemplateCopyOptions = async (inputValue, callback) => {
        try {
            const res = await axiosInstance.get(
                "/costsolution/template/autosuggestion",
                { params: { term: inputValue || '' } }
            );

            const costelement = res.data?.autosuggestion || [];
            const mapped = costelement.map((item) => ({
                label: item.label,
                value: item.value,
                model: item.model,
                modelCode: item.modelCode
            }));

            callback(mapped);
        } catch (error) {
            console.error("Cost element suggestion error:", error);
            callback([]);
        }
    };



    const handleSaveCostLine = async (submitStatus = false) => {
        if (!formData.project_id || formData.project_id === '0' || !formData.model_id || formData.model_id === '0') {
            toast.error("Project and Model are mandatory fields.");
            return;
        }
        if (isSaving) return;
        setIsSaving(true);
        setSubmitType(submitStatus ? "submit" : "save");
        try {

            const saveData = {
                id: costlineDataId,
                uom: "0",
                // customer: formData.customer || "0",
                customer: 0,
                project: formData.project_id || "0",
                model: formData.model_id || "0",
                projectDescription: formData.project_description || "",
                templateBox: showTemplateInput,
                templateName: showTemplateInput ? formData.templateName : "",
                projectperiodId:
                    selectedPeriodIndex !== null
                        ? periods[selectedPeriodIndex]?.id?.toString() || "0"
                        : "0",
                submitStatus: submitStatus,
                costLineStructure: periods.flatMap((period, periodIndex) =>
                    period.categories.flatMap((category) =>
                        category.elementlist.map((element) => ({
                            categoryId: category.id || 0,
                            period: periodIndex + 1,
                            id: element.id || "0",
                            code: element.code || "",
                            costTypeId: element.costTypeId || "0",
                            projectPeriod: period.id || 0,
                            costElementId: element.costElementId || "0",
                            basicCostValue: element.basic_cost_value || "0",
                            bufferRate: element.buffer_rate || "0",
                            capexInsurance: element.capex_insurance_percentage || "0",
                            capexMaintenance: element.capex_maintenance || "0",
                            costBuffer: element.cost_buffer || "0",
                            costEscalation: element.cost_escalation || "0",
                            costEscalationPercentage: element.cost_escalation_percentage || "0",
                            costInsurance: element.cost_insurance || "0",
                            costInterest: element.capex_cost_interest || "0",
                            costMaintenance: element.cost_maintenance || "0",
                            costMargin: element.cost_margin || "0",
                            costPeriod: element.cost_period || "0",
                            costRate: element.rate || "0",
                            costValueWithBufferMonth: element.cost_with_buffer_month || "0",
                            costValueWithBufferPeriod: element.cost_with_buffer_period || "0",
                            costValueWithoutBufferMonth: element.cost_without_buffer_month || "0",
                            costValueWithoutBufferPeriod: element.cost_without_buffer_period || "0",
                            elementRemarks: element.element_remarks || "",
                            interestRate: element.capex_interest_rate_percentage || "0",
                            marginRate: element.margin_rate_percentage || "0",
                            quantity: element.quantity || "0",
                            quantitySetup: element.quantity_setup ? JSON.stringify(element.quantity_setup) : "",
                            rateSetup: element.rate_setup ? JSON.stringify(element.rate_setup) : "",
                            rate: element.rate || "0",
                            wiRate: element.wi_rate || "0",
                        }))
                    )
                ),
            };

            const url = isEditMode
                ? `/costsolution/costlines/${costlineDataId}`
                : "/costsolution/costlines";

            const method = isEditMode ? 'put' : 'post';

            const response = await axiosInstance[method](url, saveData);

            if (response.data.success) {
                toast.success(`Cost line ${isEditMode ? 'updated' : 'saved'} successfully!`);
                setCopiedCategoryData(null);
                sessionStorage.removeItem('costline_copiedCategoryData');

                setTimeout(() => {
                    navigate("/costLine");
                }, 1000);
            }
            else {
                toast.error(response.data.message || `Failed to ${isEditMode ? 'update' : 'save'} cost line.`);
                setIsSaving(false);
            }
        } catch (error) {
            console.error("Error saving cost line:", error);
            toast.error(error.response?.data?.message || "An error occurred");
            setIsSaving(false);
        }
    };

    const NUMERIC_ONLY_FIELDS = new Set([
        'cost_period', 'quantity', 'rate',
        'cost_escalation_percentage', 'capex_interest_rate_percentage',
        'capex_maintenance', 'capex_insurance_percentage',
        'buffer_rate', 'wi_rate', 'margin_rate_percentage'
    ]);

    const sanitizeNumericInput = (value) => {
        let cleaned = value.replace(/[^0-9.]/g, '');
        const parts = cleaned.split('.');
        if (parts.length > 2) cleaned = parts[0] + '.' + parts.slice(1).join('');
        return cleaned;
    };

    const validateRowMandatoryFields = (data) => {
        const missing = [];
        if (!data.element?.trim()) missing.push("Element");
        if (!data.quantity?.toString().trim()) missing.push("Quantity");
        if (!data.rate?.toString().trim()) missing.push("Rate");
        if (missing.length > 0) {
            toast.error(`Please fill required field(s): ${missing.join(", ")}`);
            return false;
        }
        return true;
    };

    const handleDeleteRow = (e, subIndex) => {
        e.stopPropagation();
        if (selectedPeriodIndex === null || selectedCategoryIndex === null) return;
        setPendingDeleteIndex(subIndex);
        setShowDeleteConfirm(true);
    };

    const confirmDeleteRow = () => {
        if (selectedPeriodIndex !== null && selectedCategoryIndex !== null && pendingDeleteIndex !== null) {
            dispatch(deleteElement({
                periodIndex: selectedPeriodIndex,
                categoryIndex: selectedCategoryIndex,
                elementIndex: pendingDeleteIndex
            }));
            toast.success("Row deleted successfully!");
        }
        setShowDeleteConfirm(false);
        setPendingDeleteIndex(null);
    };

    const cancelDeleteRow = () => {
        setShowDeleteConfirm(false);
        setPendingDeleteIndex(null);
    };

    useEffect(() => {
        const isReturningFromSubcost = sessionStorage.getItem('subcostFlowActive') === 'true';
        if (!isReturningFromSubcost) {
            sessionStorage.removeItem('subcostNavigationData');
            sessionStorage.removeItem('subcostReturnData');
            sessionStorage.removeItem('popupState');
            sessionStorage.removeItem('subcostFlowActive');
        }
    }, []);

    useEffect(() => {
        const restoreOnCancelledReturn = () => {
            if (sessionStorage.getItem('subcostReturnData')) return;

            const navData = sessionStorage.getItem('subcostNavigationData');
            if (!navData) return;

            try {
                const parsedNav = JSON.parse(navData);
                if (parsedNav.projectData) {
                    setFormData(prev => ({
                        ...prev,
                        project_id: parsedNav.projectData.id || prev.project_id,
                        project_name: parsedNav.projectData.project || prev.project_name,
                        model_id: parsedNav.projectData.modelId || prev.model_id,
                        model_name: parsedNav.projectData.modelCode || prev.model_name,
                        business_unit: parsedNav.projectData.scope || prev.business_unit,
                        customer: parsedNav.projectData.customerContactName || prev.customer
                    }));
                }

                if (parsedNav.periodIndex !== undefined) {
                    setActivePeriod(`Period ${parsedNav.periodIndex + 1}`);
                    dispatch(selectPeriod(parsedNav.periodIndex));
                }
                if (parsedNav.categoryIndex !== undefined) {
                    dispatch(selectCategory(parsedNav.categoryIndex));
                }
            } catch (err) {
                console.error('Failed to restore data after cancelled Sub Cost Line visit:', err);
            } finally {
                sessionStorage.removeItem('subcostNavigationData');
                sessionStorage.removeItem('subcostFlowActive');
            }
        };

        restoreOnCancelledReturn();
    }, [dispatch]);

    const handleCopyCategory = (categoryIndex) => {
        const category = periods[selectedPeriodIndex]?.categories[categoryIndex];
        if (!category) return;
        const snapshot = JSON.parse(JSON.stringify(category.elementlist || []));
        setCopiedCategoryData(snapshot);
        try {
            sessionStorage.setItem('costline_copiedCategoryData', JSON.stringify(snapshot));
        } catch (err) {
            console.error('Failed to persist copied category data:', err);
        }
        toast.success(`Copied "${category.name}" category data!`);
    };

    const handlePasteCategory = (categoryIndex) => {
        if (!copiedCategoryData || copiedCategoryData.length === 0) {
            toast.error("No category data copied to paste!");
            return;
        }
        dispatch(pasteCategoryElements({
            periodIndex: selectedPeriodIndex,
            categoryIndex,
            elements: copiedCategoryData
        }));
        setCategoryDropdownVisibleFor(null);
        toast.success("Pasted category data!");
    };

    return (
        <>
            <Header onSearch={null} disableSearch={true} />
            <div className="costlinecreate">
                <div className="costlinecreateheader">
                    <div className="costlinecreateheader-left">
                        <img src={back_arrow} alt="" onClick={() => navigate(-1)}
                            style={{ cursor: "pointer" }} />
                        <p className="new_cost_line">New Cost Line</p>
                    </div>
                    <div className="costlinecreateheader-right">
                        <button className="cancel_btn" onClick={() => navigate(-1)} disabled={isSaving}>Cancel</button>
                        {isEditMode && (
                            <PDFDownloadLink
                                document={<PdfGenerate summaryData={summaryData} periods={periods} projectDetails={pdfProjectDetails || formData} />}
                                fileName="costline_summary.pdf"
                            >
                                {({ blob, url, loading, error }) => {
                                    console.log("PDFDownloadLink state:", { blob, url, loading, error });
                                    return (
                                        <button className="clear_btn" disabled={loading}>
                                            {loading ? "Generating PDF..." : "PDF"}
                                        </button>
                                    );
                                }}
                            </PDFDownloadLink>
                        )}
                        <button
                            className="clear_btn"
                            disabled={isSaving}
                            onClick={() => {
                                setFormData({
                                    project_id: '',
                                    project_name: '',
                                    model_id: '',
                                    model_name: '',
                                    business_unit: '',
                                    customer: '',
                                    project_description: ''
                                });
                                dispatch(setPeriods([]));
                                setProjectInput("");
                                setselectedprojectId(0);
                                setselectedproject(0);
                                setActivePeriod("Summary");
                                setShowTemplateInput(false);
                                setCopiedCategoryData(null);
                                sessionStorage.removeItem('costline_copiedCategoryData');
                                toast.success("Form cleared successfully");
                            }}
                        >
                            Clear
                        </button>
                        <button className="save_btn" onClick={() => handleSaveCostLine(false)} disabled={isSaving}>
                            {isSaving && submitType === "save" ? "Saving..." : "Save"}
                        </button>
                        <button className="save_btn" onClick={() => handleSaveCostLine(true)} disabled={isSaving}>
                            {isSaving && submitType === "submit" ? "Submitting..." : "Submit"}
                        </button>
                    </div>
                </div>

                <div className="projectdetailsform">
                    <div className="costlineprojects">
                        <label>Project <span style={{ color: 'red' }}>*</span></label>
                        <div className="inputfield" style={{ position: 'relative' }}>
                            <AsyncSelect
                                cacheOptions
                                defaultOptions
                                loadOptions={loadProjectOptions}
                                onChange={(selectedOption) => {
                                    if (selectedOption) {
                                        setProjectInput(selectedOption.label);
                                        setFormData(prev => ({
                                            ...prev,
                                            project_id: selectedOption.value,
                                            project_name: selectedOption.label
                                        }));
                                        setselectedproject(selectedOption.value);
                                        setselectedprojectId(selectedOption.value);
                                        setCopiedCategoryData(null);
                                        sessionStorage.removeItem('costline_copiedCategoryData');
                                        fetchProjectDetails(selectedOption.value);
                                    } else {
                                        setProjectInput('');
                                        setFormData({
                                            project_id: '',
                                            project_name: '',
                                            model_id: '',
                                            model_name: '',
                                            business_unit: '',
                                            customer: '',
                                            project_description: '',
                                            templateName: ''
                                        });
                                        setselectedproject('');
                                        setselectedprojectId('');
                                        setShowTemplateInput(false);
                                        setSelectedTemplate(null);
                                        setShowReuseTemplateConfirmation(false);
                                        setMappedTemplateToReuse(null);
                                        setCopiedCategoryData(null);
                                        sessionStorage.removeItem('costline_copiedCategoryData');
                                    }
                                }}

                                value={formData.project_name ? {
                                    label: formData.project_name,
                                    value: formData.project_id
                                } : null}
                                placeholder="Search project..."
                                isClearable
                                styles={{
                                    control: (base, state) => ({
                                        ...base,
                                        minHeight: '34px',
                                        borderRadius: '12px',
                                        fontSize: '13px',
                                        width: '100%',
                                        borderColor: state.isFocused ? '#454CF2' : '#DCDFE4',
                                        boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                                        '&:hover': {
                                            borderColor: '#454CF2'
                                        }
                                    }),
                                    container: (base) => ({
                                        ...base,
                                        width: '100%'
                                    }),
                                    menu: (base) => ({
                                        ...base,
                                        zIndex: 999,
                                        fontSize: '12px',
                                        marginTop: '4px',
                                        boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                                    }),
                                    option: (base, { isFocused }) => ({
                                        ...base,
                                        backgroundColor: isFocused ? '#f2f2f2' : '#fff',
                                        color: '#333',
                                        padding: '10px',
                                        cursor: 'pointer',
                                        borderBottom: '1px solid #eee',
                                        '&:active': {
                                            backgroundColor: '#f2f2f2'
                                        }
                                    }),
                                    dropdownIndicator: (base) => ({
                                        ...base,
                                        padding: '8px'
                                    }),
                                    clearIndicator: (base) => ({
                                        ...base,
                                        padding: '8px'
                                    })
                                }}
                            />
                        </div>
                    </div>
                    <div className="costlineprojectsdesc">
                        <label>Project Description</label>
                        <div className="inputfield">
                            <input
                                type="text"
                                value={formData.project_description || ''}
                                onChange={(e) => setFormData({ ...formData, project_description: e.target.value })}
                            />
                        </div>
                    </div>
                    <div className="costlinebusinessunit">
                        <label>Business Unit</label>
                        <div className="inputfield">
                            <input
                                type="text"
                                value={formData.business_unit || ''}
                                onChange={(e) => setFormData({ ...formData, business_unit: e.target.value })}
                            />
                        </div>
                    </div>
                    <div className="costlinecustomer">
                        <label>Customer</label>
                        <div className="inputfield">
                            <input
                                type="text"
                                value={formData.customer || ''}
                                onChange={(e) => setFormData({ ...formData, customer: e.target.value })}
                            />
                        </div>
                    </div>
                    <div className="costlinebusinessunit">
                        <label>Model <span style={{ color: 'red' }}>*</span></label>
                        <div className="inputfield">
                            <input
                                type="text"
                                value={formData.model_name || ''}
                                readOnly
                                style={{ backgroundColor: '#F6F6F6', cursor: 'not-allowed' }}
                            />
                        </div>
                    </div>
                    {!isEditMode && (
                        <div className="costlinebusinessunit">
                            <label>Copy Template Form</label>
                            <div className="inputfield">
                                <div style={{ margin: '0px' }}>
                                    <AsyncSelect
                                        cacheOptions
                                        defaultOptions
                                        loadOptions={loadTemplateCopyOptions}
                                        onChange={handleTemplateChange}
                                        value={selectedTemplate}
                                        placeholder={formData.project_id ? "Search ..." : "Please select a project first"}
                                        isClearable
                                        isDisabled={!formData.project_id}
                                        styles={{
                                            control: (base, state) => ({
                                                ...base,
                                                minHeight: '30px',
                                                borderRadius: '12px',
                                                fontSize: '13px',
                                                width: '100%',
                                                borderColor: state.isDisabled ? '#DCDFE4' : state.isFocused ? '#454CF2' : '#DCDFE4',
                                                backgroundColor: state.isDisabled ? '#F6F6F6' : '#fff',
                                                cursor: state.isDisabled ? 'not-allowed' : 'default',
                                                boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                                                '&:hover': {
                                                    borderColor: state.isDisabled ? '#DCDFE4' : '#454CF2'
                                                }
                                            }),
                                            container: (base) => ({
                                                ...base,
                                                width: '100%'
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 999,
                                                fontSize: '12px',
                                                marginTop: '4px',
                                                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                                            }),
                                            option: (base, { isFocused }) => ({
                                                ...base,
                                                backgroundColor: isFocused ? '#f2f2f2' : '#fff',
                                                color: '#333',
                                                padding: '10px',
                                                cursor: 'pointer',
                                                borderBottom: '1px solid #eee',
                                                '&:active': {
                                                    backgroundColor: '#f2f2f2'
                                                }
                                            }),
                                            dropdownIndicator: (base) => ({
                                                ...base,
                                                padding: '8px'
                                            }),
                                            clearIndicator: (base) => ({
                                                ...base,
                                                padding: '8px'
                                            })
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    {!isEditMode && showTemplateConfirmation && (
                        <div className="templatecostline-popup-overlay">
                            <div className="templatecostline-confirmation-popup">
                                <h3>Confirm Template Application</h3>
                                <p>If you proceed, previous category values will be cleared.</p>
                                <div className="templatecostline-confirmation-buttons">
                                    <button className="templatecostline-cancel-btn" onClick={handleTemplateCancel}>
                                        Cancel
                                    </button>
                                    <button className="templatecostline-proceed-btn" onClick={handleTemplateProceed}>
                                        Proceed
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    {!isEditMode && showReuseTemplateConfirmation && (
                        <div className="templatecostline-popup-overlay">
                            <div className="templatecostline-confirmation-popup">
                                <h3>Reuse Mapped Template</h3>
                                <p>A template is already mapped to this project. Do you want to reuse the existing template?</p>
                                <div className="templatecostline-confirmation-buttons">
                                    <button className="templatecostline-cancel-btn" onClick={handleReuseTemplateCancel}>
                                        No
                                    </button>
                                    <button className="templatecostline-proceed-btn" onClick={handleReuseTemplateProceed}>
                                        Yes
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    {!isEditMode && (
                        <div className="template_name">
                            <span>
                                <input type="checkbox" id="templateCheckbox" checked={showTemplateInput}
                                    onChange={() => setShowTemplateInput(!showTemplateInput)} />
                                <label htmlFor="templateCheckbox">Template Name</label>
                            </span>
                            {showTemplateInput && (
                                <div className="inputfield">
                                    <input
                                        type="text"
                                        value={formData.templateName || ''}
                                        onChange={(e) => setFormData({ ...formData, templateName: e.target.value })}
                                    />
                                </div>
                            )}
                        </div>
                    )}
                </div>

                <div className="categorydetails">
                    <PeriodTabs />
                    {activePeriod === "Summary" ? (
                        <div className="dashboard-content">
                            <div className="cost-section">
                                <CostTable
                                    data={summaryData.withBufferMonth}
                                    title="Cost with Buffer (Month)"
                                    periods={periods}
                                />
                            </div>
                            <div className="cost-section">
                                <CostTable
                                    data={summaryData.withoutBufferMonth}
                                    title="Cost Without Buffer (Month)"
                                    periods={periods}
                                />
                            </div>
                            <div className="cost-section">
                                <CostTable
                                    data={summaryData.withBufferPeriod}
                                    title="Cost With Buffer (Period)"
                                    periods={periods}
                                />
                            </div>
                            <div className="cost-section">
                                <CostTable
                                    data={summaryData.withoutBufferPeriod}
                                    title="Cost Without Buffer (Period)"
                                    periods={periods}
                                />
                            </div>
                            <div className="cost-section">
                                <CostComparisonTable
                                    withData={summaryData.withBufferMonth}
                                    withoutData={summaryData.withoutBufferMonth}
                                    title="Cost Comparison: With/Without Buffer (per month)"
                                    periods={periods}
                                />
                            </div>
                            <div className="cost-section">
                                <CostComparisonTable
                                    withData={summaryData.withBufferPeriod}
                                    withoutData={summaryData.withoutBufferPeriod}
                                    title="Cost Comparison: With/Without Buffer (per period)"
                                    periods={periods}
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="categorylistdetails">
                            <div className="categoriesdetails">
                                {periods[selectedPeriodIndex]?.categories?.map((category, index) => (
                                    <div key={category.id} className="category_item">
                                        <div
                                            className={`category_header ${selectedCategoryIndex === index ? "Selected" : ""}`}
                                            onClick={() => dispatch(selectCategory(index))}
                                        >
                                            <span className="category_name">{category.name}</span>
                                            <span className="category_header_actions">
                                                <button
                                                    type="button"
                                                    className="category_icon_btn"
                                                    title="Copy category"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleCopyCategory(index);
                                                    }}
                                                >
                                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                        <rect x="9" y="9" width="12" height="12" rx="2" stroke="currentColor" strokeWidth="2" />
                                                        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" stroke="currentColor" strokeWidth="2" />
                                                    </svg>
                                                </button>
                                                <button
                                                    type="button"
                                                    className="category_icon_btn"
                                                    title={copiedCategoryData ? "Paste category here" : "Copy a category first"}
                                                    disabled={!copiedCategoryData}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handlePasteCategory(index);
                                                    }}
                                                >
                                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                                                        <rect x="8" y="2" width="8" height="4" rx="1" stroke="currentColor" strokeWidth="2" />
                                                        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" stroke="currentColor" strokeWidth="2" />
                                                    </svg>
                                                </button>
                                                <span className="dropdown_arrow">
                                                    {selectedCategoryIndex === index ? '▼' : '▶'}
                                                </span>
                                            </span>
                                        </div>

                                        {selectedCategoryIndex === index && (
                                            <div className="sub_header" style={{ backgroundColor: '#EDF3F9' }}>
                                                <div className="scrollable-container">
                                                    <table className="element_list">
                                                        <thead>
                                                            <tr className="element_details_header">
                                                                <th className="element_header_column" style={{ minWidth: '50px', width: '50px' }}></th>
                                                                <th className="element_header_column" style={{ minWidth: '50px', width: '50px' }}>S.NO</th>
                                                                <th className="element_header_column">PERIOD</th>
                                                                <th className="element_header_column" >ELEMENT</th>
                                                                <th className="element_header_column element_remarks_column">ELEMENT REMARKS</th>
                                                                <th className="element_header_column">COST PERIOD</th>
                                                                <th className="element_header_column">QUANTITY</th>
                                                                <th className="element_header_column">RATE</th>
                                                                <th className="element_header_column">GROSS VALUE</th>
                                                                <th className="element_header_column">MARGIN RATE %</th>
                                                                <th className="element_header_column">WI RATE %</th>
                                                                <th className="element_header_column">
                                                                    <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                        COST ESCALATION PERCENTAGE
                                                                        <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.COST_ESCALATION_PERCENTAGE, e)}
                                                                            onMouseLeave={handleFormulaLeave} />
                                                                    </span>
                                                                </th>
                                                                <th className="element_header_column">
                                                                    <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                        CAPEX INTEREST RATE
                                                                        <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.CAPEX_INTEREST_RATE, e)}
                                                                            onMouseLeave={handleFormulaLeave} />
                                                                    </span>
                                                                </th>
                                                                <th className="element_header_column">
                                                                    <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                        CAPEX MAINTENANCE
                                                                        <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.CAPEX_MAINTENANCE, e)}
                                                                            onMouseLeave={handleFormulaLeave} />
                                                                    </span>
                                                                </th>
                                                                <th className="element_header_column">
                                                                    <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                        CAPEX INSURANCE
                                                                        <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.CAPEX_INSURANCE, e)}
                                                                            onMouseLeave={handleFormulaLeave} />
                                                                    </span>
                                                                </th>
                                                                <th className="element_header_column">BUFFER RATE</th>
                                                                <th className="element_header_column">
                                                                    <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                        BASIC COST VALUE
                                                                        <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.BASIC_COST_VALUE, e)}
                                                                            onMouseLeave={handleFormulaLeave} />
                                                                    </span>
                                                                </th>
                                                                <th className="element_header_column">
                                                                    <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                        COST ESCALATION
                                                                        <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.COST_ESCALATION, e)}
                                                                            onMouseLeave={handleFormulaLeave} />
                                                                    </span>
                                                                </th>
                                                                <th className="element_header_column">
                                                                    <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                        CAPEX COST INTEREST
                                                                        <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.CAPEX_COST_INTEREST, e)}
                                                                            onMouseLeave={handleFormulaLeave} />
                                                                    </span>
                                                                </th>
                                                                <th className="element_header_column">
                                                                    <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                        COST MAINTENANCE
                                                                        <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.COST_MAINTENANCE, e)}
                                                                            onMouseLeave={handleFormulaLeave} />
                                                                    </span>
                                                                </th>
                                                                <th className="element_header_column">
                                                                    <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                        COST INSURANCE
                                                                        <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.COST_INSURANCE, e)}
                                                                            onMouseLeave={handleFormulaLeave} />
                                                                    </span>
                                                                </th>
                                                                <th className="element_header_column">
                                                                    <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                        COST BUFFER
                                                                        <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.COST_BUFFER, e)}
                                                                            onMouseLeave={handleFormulaLeave} />
                                                                    </span>
                                                                </th>
                                                                <th className="element_header_column">
                                                                    <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                        COST MARGIN
                                                                        <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.COST_MARGIN, e)}
                                                                            onMouseLeave={handleFormulaLeave} />
                                                                    </span>
                                                                </th>
                                                                <th className="element_header_column">
                                                                    <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                        COST WI
                                                                        <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.COST_WI, e)}
                                                                            onMouseLeave={handleFormulaLeave} />
                                                                    </span>
                                                                </th>
                                                                <th className="element_header_column">
                                                                    <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                        COST WITH BUFFER(MONTH)
                                                                        <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.COST_WITH_BUFFER_MONTH, e)}
                                                                            onMouseLeave={handleFormulaLeave} />
                                                                    </span>
                                                                </th>
                                                                <th className="element_header_column">
                                                                    <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                        COST W/O BUFFER(MONTH)
                                                                        <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.COST_WITHOUT_BUFFER_MONTH, e)}
                                                                            onMouseLeave={handleFormulaLeave} />
                                                                    </span>
                                                                </th>
                                                                <th className="element_header_column">
                                                                    <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                        COST WITH BUFFER(PERIOD)
                                                                        <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.COST_WITH_BUFFER_PERIOD, e)}
                                                                            onMouseLeave={handleFormulaLeave} />
                                                                    </span>
                                                                </th>
                                                                <th className="element_header_column">
                                                                    <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                                        COST W/O BUFFER(PERIOD)
                                                                        <img src={formula_icon} alt='' onMouseEnter={(e) => handleFormulaHover(FORMULAS.COST_WITHOUT_BUFFER_PERIOD, e)}
                                                                            onMouseLeave={handleFormulaLeave} />
                                                                    </span>
                                                                </th>
                                                            </tr>
                                                            {tooltip.visible && (
                                                                <div style={tooltipStyle}>
                                                                    {tooltip.content}
                                                                </div>
                                                            )}
                                                        </thead>
                                                        <tbody>
                                                            {periods[selectedPeriodIndex]?.categories[selectedCategoryIndex]?.elementlist.map((sub, subIndex) => (
                                                                <tr key={subIndex} className="element_details_row">
                                                                    <td className="element_value_row" style={{ minWidth: '50px', width: '50px' }}>
                                                                        <img
                                                                            src={delete_icon}
                                                                            alt="Delete row"
                                                                            onClick={(e) => handleDeleteRow(e, subIndex)}
                                                                            style={{ cursor: 'pointer', width: '27px', height: '27px' }}
                                                                            title="Delete this row"
                                                                        />
                                                                    </td>
                                                                    <td className="element_value_row" style={{ minWidth: '50px', width: '50px' }}>{subIndex + 1}</td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>
                                                                        {periods[selectedPeriodIndex]?.month || ''}
                                                                    </td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)} title={sub.element}>
                                                                        <span className="cell-text-truncate">{sub.element}</span>
                                                                    </td>
                                                                    <td className="element_value_row element_remarks_column" onClick={() => togglePopup(subIndex, sub)} title={sub.element_remarks}>
                                                                        <span className="cell-text-truncate">{sub.element_remarks}</span>
                                                                    </td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_period}</td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>
                                                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                                                            {sub.quantity}
                                                                            <img
                                                                                src={subcostlinearrow}
                                                                                alt="arrow"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    togglePopup(subIndex, sub);
                                                                                    handleSubcostlineArrowClick(e, 'quantity', sub, subIndex);
                                                                                }}
                                                                                style={{ cursor: 'pointer', marginLeft: '5px' }}
                                                                            />
                                                                        </span>
                                                                    </td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>
                                                                        <span style={{ display: 'flex', alignItems: 'center' }}>
                                                                            {sub.rate}
                                                                            <img
                                                                                src={subcostlinearrow}
                                                                                alt="arrow"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    togglePopup(subIndex, sub);
                                                                                    handleSubcostlineArrowClick(e, 'rate', sub, subIndex);
                                                                                }}
                                                                                style={{ cursor: 'pointer', marginLeft: '5px' }}
                                                                            />
                                                                        </span>
                                                                    </td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.gross_value}</td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.margin_rate_percentage}</td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.wi_rate}</td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_escalation_percentage}</td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.capex_interest_rate_percentage}</td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.capex_maintenance}</td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.capex_insurance_percentage}</td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.buffer_rate}</td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.basic_cost_value}</td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_escalation}</td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.capex_cost_interest}</td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_maintenance}</td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_insurance}</td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_buffer}</td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_margin}</td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_wi}</td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_with_buffer_month}</td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_without_buffer_month}</td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_with_buffer_period}</td>
                                                                    <td className="element_value_row" onClick={() => togglePopup(subIndex, sub)}>{sub.cost_without_buffer_period}</td>
                                                                    {showPopup && (
                                                                        <div className="popup-overlay" onClick={() => togglePopup(subIndex, sub)}>
                                                                            <div className="popup-box" onClick={(e) => e.stopPropagation()} style={{ overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth' }}>
                                                                                <div className="popup-element-header">
                                                                                    <p>{`Period ${selectedPeriodIndex + 1} - ${periods[selectedPeriodIndex]?.categories[selectedCategoryIndex]?.name || ''} / ${getOrdinal(editingIndex + 1)} Row`}</p>
                                                                                    <div className="popup-header-actions">
                                                                                        <button className="costline-popup-submit-btn" onClick={handleSave}>Submit</button>
                                                                                        <button
                                                                                            className="x-btn"
                                                                                            onClick={() => setShowPopup(false)}
                                                                                            aria-label="Close"
                                                                                            style={{
                                                                                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                                                                background: 'transparent', border: 'none', borderRadius: '6px',
                                                                                                width: '32px', height: '32px', cursor: 'pointer', color: '#475867'
                                                                                            }}
                                                                                        >
                                                                                            <X size={18} strokeWidth={2} />
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="popup-grid-container">
                                                                                    <div className="popup-grid-row">
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Period</label>
                                                                                            <input
                                                                                                type="text"
                                                                                                style={{ margin: '0px', backgroundColor: '#F6F6F6' }}
                                                                                                value={periods[selectedPeriodIndex]?.month || ''}
                                                                                                readOnly
                                                                                            />
                                                                                        </div>
                                                                                        {/* Replace your existing AsyncSelect in the popup with this: */}
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Element</label>
                                                                                            <div style={{ margin: '0px' }}>
                                                                                                <AsyncSelect
                                                                                                    cacheOptions
                                                                                                    defaultOptions
                                                                                                    loadOptions={loadCostElementOptions}
                                                                                                    onChange={(selectedOption) => {
                                                                                                        const newData = {
                                                                                                            ...editingData,
                                                                                                            element: selectedOption ? selectedOption.label.replace(/^.*? - /, '') : '',
                                                                                                            element_value: selectedOption ? selectedOption.value : '',
                                                                                                            costElementId: selectedOption ? selectedOption.value : '',
                                                                                                            costElementCode: selectedOption ? selectedOption.code : '',
                                                                                                        };
                                                                                                        setEditingData(newData);
                                                                                                    }}
                                                                                                    value={editingData.element ? {
                                                                                                        label: editingData.costElementCode ? `${editingData.costElementCode} - ${editingData.element}` : editingData.element,
                                                                                                        value: editingData.element_value || editingData.element
                                                                                                    } : null}
                                                                                                    placeholder="Search ..."
                                                                                                    isClearable
                                                                                                    styles={{
                                                                                                        control: (base, state) => ({
                                                                                                            ...base,
                                                                                                            minHeight: '20px',
                                                                                                            height: '30px',
                                                                                                            borderRadius: '8px',
                                                                                                            fontSize: '13px',
                                                                                                            borderColor: state.isFocused ? '#454CF2' : '#DCDFE4',
                                                                                                            boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                                                                                                            '&:hover': {
                                                                                                                borderColor: '#454CF2'
                                                                                                            }
                                                                                                        }),
                                                                                                        container: (base) => ({ ...base, width: '100%' }),
                                                                                                        menu: (base) => ({
                                                                                                            ...base,
                                                                                                            zIndex: 999,
                                                                                                            fontSize: '12px',
                                                                                                            marginTop: '4px',
                                                                                                            boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
                                                                                                        }),
                                                                                                        placeholder: (base) => ({
                                                                                                            ...base,
                                                                                                            color: '#999',
                                                                                                            fontSize: '13px',
                                                                                                            margin: 0,
                                                                                                            position: 'absolute',
                                                                                                            top: '50%',
                                                                                                            transform: 'translateY(-50%)'
                                                                                                        }),
                                                                                                        input: (base) => ({
                                                                                                            ...base,
                                                                                                            padding: '0 8px',
                                                                                                            margin: 0,
                                                                                                            height: '28px'
                                                                                                        }),
                                                                                                        singleValue: (base) => ({
                                                                                                            ...base,
                                                                                                            fontSize: '13px',
                                                                                                            paddingLeft: '8px',
                                                                                                            margin: 0
                                                                                                        }),
                                                                                                        dropdownIndicator: (base) => ({
                                                                                                            ...base,
                                                                                                            padding: '4px'
                                                                                                        }),
                                                                                                        clearIndicator: (base) => ({
                                                                                                            ...base,
                                                                                                            padding: '4px'
                                                                                                        })
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Cost Period</label>
                                                                                            <input type="text" style={{ margin: '0px' }} value={editingData.cost_period || ''} onChange={(e) => handleInputChange(e, 'cost_period')} />
                                                                                        </div>
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Element Remarks</label>
                                                                                            <input type="text" style={{ margin: '0px' }} value={editingData.element_remarks || ''} onChange={(e) => handleInputChange(e, 'element_remarks')} />
                                                                                        </div>
                                                                                    </div>

                                                                                    {/* Row 2 */}
                                                                                    <div className="popup-grid-row">
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Quantity <span style={{ color: 'red' }}>*</span></label>
                                                                                            <span className="input-with-icon-inside">
                                                                                                <input
                                                                                                    type="text"
                                                                                                    style={{ margin: '0px' }}
                                                                                                    inputMode="decimal"
                                                                                                    value={editingData?.quantity || ''}
                                                                                                    onChange={(e) => handleInputChange(e, 'quantity')}
                                                                                                />
                                                                                                <img
                                                                                                    src={subcostlinearrow}
                                                                                                    alt="arrow"
                                                                                                    width={16}
                                                                                                    height={16}
                                                                                                    onClick={(e) => {
                                                                                                        e.stopPropagation();
                                                                                                        handleSubcostlineArrowClick(e, 'quantity', editingData, editingIndex);
                                                                                                    }}
                                                                                                    style={{ cursor: 'pointer' }}
                                                                                                />
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Rate <span style={{ color: 'red' }}>*</span></label>
                                                                                            <span className="input-with-icon-inside">
                                                                                                <input
                                                                                                    type="text"
                                                                                                    inputMode="decimal"
                                                                                                    style={{ margin: '0px' }}
                                                                                                    value={editingData?.rate || ''}
                                                                                                    onChange={(e) => handleInputChange(e, 'rate')}
                                                                                                />
                                                                                                <img
                                                                                                    src={subcostlinearrow}
                                                                                                    alt="arrow"
                                                                                                    width={16}
                                                                                                    height={16}
                                                                                                    onClick={(e) => {
                                                                                                        e.stopPropagation();
                                                                                                        handleSubcostlineArrowClick(e, 'rate', editingData, editingIndex);
                                                                                                    }}
                                                                                                    style={{ cursor: 'pointer' }}
                                                                                                />
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Gross Value</label>
                                                                                            <input type="text" style={{ margin: '0px', backgroundColor: '#F6F6F6' }} value={editingData?.gross_value || ''} onChange={(e) => handleInputChange(e, 'gross_value')}
                                                                                                readOnly
                                                                                            />
                                                                                        </div>
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Basic Cost Value</label>
                                                                                            <input type="text" style={{ margin: '0px', backgroundColor: '#F6F6F6' }} value={editingData?.basic_cost_value || ''} onChange={(e) => handleInputChange(e, 'basic_cost_value')} readOnly />

                                                                                        </div>
                                                                                    </div>

                                                                                    {/* Row 3 */}
                                                                                    <div className="popup-grid-row">
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Cost Escalation %</label>
                                                                                            <input type="text" style={{ margin: '0px' }} value={editingData?.cost_escalation_percentage || ''} onChange={(e) => handleInputChange(e, 'cost_escalation_percentage')} />
                                                                                        </div>
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Cost Escalation</label>
                                                                                            <input type="text" style={{ margin: '0px', backgroundColor: '#F6F6F6' }} value={editingData?.cost_escalation || ''} onChange={(e) => handleInputChange(e, 'cost_escalation')} readOnly />
                                                                                        </div>
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Capex Interest Rate %</label>
                                                                                            <input type="text" style={{ margin: '0px' }} value={editingData?.capex_interest_rate_percentage || ''} onChange={(e) => handleInputChange(e, 'capex_interest_rate_percentage')} />
                                                                                        </div>
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Cost Maintenance</label>
                                                                                            <input type="text" style={{ margin: '0px', backgroundColor: '#F6F6F6' }} value={editingData?.cost_maintenance || ''} onChange={(e) => handleInputChange(e, 'cost_maintenance')} readOnly />
                                                                                        </div>
                                                                                    </div>

                                                                                    {/* Row 4 */}
                                                                                    <div className="popup-grid-row">
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Capex Maintenance %</label>
                                                                                            <input
                                                                                                type="text"
                                                                                                style={{ margin: '0px' }}
                                                                                                value={editingData?.capex_maintenance || ''}
                                                                                                onChange={(e) => handleInputChange(e, 'capex_maintenance')}
                                                                                            />
                                                                                        </div>
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Cost Maintenance</label>
                                                                                            <input
                                                                                                type="text"
                                                                                                style={{ margin: '0px', backgroundColor: '#F6F6F6' }}
                                                                                                value={editingData?.cost_maintenance || ''}
                                                                                                readOnly
                                                                                            />
                                                                                        </div>
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Capex Insurance %</label>
                                                                                            <input type="text" style={{ margin: '0px' }} value={editingData?.capex_insurance_percentage || ''} onChange={(e) => handleInputChange(e, 'capex_insurance_percentage')} />
                                                                                        </div>
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Cost Insurance</label>
                                                                                            <input type="text" style={{ margin: '0px', backgroundColor: '#F6F6F6' }} value={editingData?.cost_insurance || ''} onChange={(e) => handleInputChange(e, 'cost_insurance')} readOnly />
                                                                                        </div>
                                                                                    </div>

                                                                                    {/* Row 5 */}
                                                                                    <div className="popup-grid-row">
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Buffer Rate %</label>
                                                                                            <input type="text" style={{ margin: '0px' }} value={editingData?.buffer_rate || ''} onChange={(e) => handleInputChange(e, 'buffer_rate')} />
                                                                                        </div>
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Cost Buffer</label>
                                                                                            <input type="text" style={{ margin: '0px', backgroundColor: '#F6F6F6' }} value={editingData?.cost_buffer || ''} onChange={(e) => handleInputChange(e, 'cost_buffer')} readOnly />
                                                                                        </div>
                                                                                        <div className="popup-grid-item">
                                                                                            <label>WI Rate %</label>
                                                                                            <input type="text" style={{ margin: '0px' }} value={editingData?.wi_rate || ''} onChange={(e) => handleInputChange(e, 'wi_rate')} />
                                                                                        </div>
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Cost WI</label>
                                                                                            <input type="text" style={{ margin: '0px', backgroundColor: '#F6F6F6' }} value={editingData?.cost_wi || ''} onChange={(e) => handleInputChange(e, 'cost_wi')} readOnly />
                                                                                        </div>
                                                                                    </div>

                                                                                    {/* Row 6 */}
                                                                                    <div className="popup-grid-row">
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Margin Rate %</label>
                                                                                            <input type="text" style={{ margin: '0px' }} value={editingData?.margin_rate_percentage || ''} onChange={(e) => handleInputChange(e, 'margin_rate_percentage')} />
                                                                                        </div>
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Cost Margin</label>
                                                                                            <input type="text" style={{ margin: '0px', backgroundColor: '#F6F6F6' }} value={editingData?.cost_margin || ''} onChange={(e) => handleInputChange(e, 'cost_margin')} readOnly />
                                                                                        </div>
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Cost with Buffer (Month)</label>
                                                                                            <input type="text" style={{ margin: '0px', backgroundColor: '#F6F6F6' }} value={editingData?.cost_with_buffer_month || ''} onChange={(e) => handleInputChange(e, 'cost_with_buffer_month')} readOnly />
                                                                                        </div>
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Cost without Buffer (Month)</label>
                                                                                            <input type="text" style={{ margin: '0px', backgroundColor: '#F6F6F6' }} value={editingData?.cost_without_buffer_month || ''} onChange={(e) => handleInputChange(e, 'cost_without_buffer_month')} readOnly />
                                                                                        </div>
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Cost with Buffer (Period)</label>
                                                                                            <input type="text" style={{ margin: '0px', backgroundColor: '#F6F6F6' }} value={editingData?.cost_with_buffer_period || ''} onChange={(e) => handleInputChange(e, 'cost_with_buffer_period')} readOnly />
                                                                                        </div>
                                                                                        <div className="popup-grid-item">
                                                                                            <label>Cost without Buffer (Period)</label>
                                                                                            <input type="text" style={{ margin: '0px', backgroundColor: '#F6F6F6' }} value={editingData?.cost_without_buffer_period || ''} onChange={(e) => handleInputChange(e, 'cost_without_buffer_period')} readOnly />
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                {/* <div className="done-btn">
                                                                                    <button onClick={handleSave}>Done</button>
                                                                                </div> */}
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="add_new_row" onClick={handleAddRow}>
                                                    <span className="add_new_row_popup"><img src={plus_icon} alt="" />Add Row</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
            {isSaving && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.4)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 99999,
                    backdropFilter: 'blur(2px)'
                }}>
                    <div style={{
                        backgroundColor: '#fff',
                        padding: '24px 40px',
                        borderRadius: '12px',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '12px'
                    }}>
                        <div style={{
                            width: '35px',
                            height: '35px',
                            border: '3px solid #f3f3f3',
                            borderTop: '3px solid #454CF2',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite'
                        }}></div>
                        <span style={{ fontSize: '14px', fontWeight: '500', color: '#333' }}>
                            {submitType === "submit" ? "Submitting Costline..." : "Saving Costline..."}
                        </span>
                    </div>
                    <style>{`
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }
                    `}</style>
                </div>
            )}
            <ConfirmDialog
                open={showDeleteConfirm}
                title="Delete Row"
                message="Are you sure you want to delete this row? This action cannot be undone."
                confirmText="Delete"
                cancelText="Cancel"
                onConfirm={confirmDeleteRow}
                onCancel={cancelDeleteRow}
            />
            <CommonFooter />
            <ToastContainer position="top-right" autoClose={2000} hideProgressBar={false} />
        </>
    );
};

export default CostLineCreate;
